"use strict";

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultErrorNo = 500;

var APIError =
/*#__PURE__*/
function (_Error) {
  _inherits(APIError, _Error);

  function APIError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var errno = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultErrorNo;
    var errors = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, APIError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(APIError).call(this, message));
    _this.name = 'APIError';
    _this.errno = errno;
    _this.errors = errors;
    return _this;
  }

  return APIError;
}(_wrapNativeSuper(Error));

exports.APIError = APIError;